import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDatepickerInputEvent } from '@angular/material';
import { TravelService } from '../../services/travel/travel.service';
import { User } from 'src/app/models/user';
import { DatePipe } from '@angular/common';
import { AuthService } from 'src/app/modules/login/services/auth/auth.service';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { Travel } from 'src/app/models/travel';
import { TravelSummaryAddComponent } from '../travel-summary-add/travel-summary-add.component';
import {map, startWith} from 'rxjs/operators';

import * as _moment from 'moment';

import {defaultFormat as _rollupMoment} from 'moment';
import { TravelBookingAddComponent } from '../travel-booking-add/travel-booking-add.component';
import { TravelSummaryViewComponent } from '../travel-summary-view/travel-summary-view.component';
import { TravelBookingViewComponent } from '../travel-booking-view/travel-booking-view.component';
import { travelItineraryUrl, travelAuthorUrl, travelRequestUrl, TRAVELTYPE, BOOKINGTYPE, BOOKINGMETHOD, PURPOSE} from 'src/app/modules/shared/common/api';
import { FunctionsService } from 'src/app/modules/shared/services/functions.service';
import { Observable } from 'rxjs';
import { AddressService } from 'src/app/modules/shared/services/address/address.service';
import { LookUpLocationComponent } from 'src/app/modules/shared/components/look-up-location/look-up-location.component';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';
import { ConfirmationMessageComponent } from 'src/app/modules/shared/components/confirmation-message/confirmation-message.component';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY-MM-DD',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'YYYY-MM-DD',
  },
};

export interface City {
  name: string;
}

@Component({
  selector: 'app-travel-authorization-add',
  templateUrl: './travel-authorization-add.component.html',
  styleUrls: ['./travel-authorization-add.component.scss']
})
export class TravelAuthorizationAddComponent implements OnInit {

  _user: User;
  travel: Travel;
  formGroup: FormGroup;
  objectKeys = Object.keys;
  loading:boolean = false;
  isCharged:boolean = false;
  isOther:boolean = false;
  isCurrency:boolean = false;
  displayForm:boolean = false;
  canDelete:boolean = false;
  doneInfo:boolean = false;
  doneTransaction:boolean = false;
  isClickedName:boolean = false;
  isClickedId:boolean = false;
  successMessage: String = '';
  employeeDetail = [];

  summarymsg = '';
  index = 0;
  pipe = new DatePipe('en-US');
  
  option =  {
    btnOk:'Yes',
    btnCancel: 'Cancel',
  }

  travelOption = ["Individual","Group"];
  purposeOption = PURPOSE;
  natureOption = ["Inbound","Outbound"];
  departmentList = JSON.parse(localStorage.getItem('department'));
  positionList = JSON.parse(localStorage.getItem('position'));
  expensesList:any[];
  countdays=[];

  currencyOption = [
    {id:1,name:"PHP"},
    {id:2,name:"USD"},
    {id:3,name:"Others"}
  ];
  chargeOption = [
    {id:1,name:"Rose Pharmacy"},
    {id:2,name:"DF"},
    {id:3,name:"Supplier"},
    {id:4,name:"RRHI"},
    {id:5,name:"Southstar Drug"}
  ];
  bookedOption = BOOKINGTYPE;
  bookedMethod = BOOKINGMETHOD;
  billOption = ["Store Support Center","Requestor"];

  dialogConfig:any;
  summaryDetail:any;
  currDate: any;
  msg:any;
  mxDate:any;
  fDate: any;
  tDate: any;
  forDate: any;
  toDate: any;
  nameMismatch: boolean = true
  nameAndIdMismatch: boolean = false
  nameEmployeeCompare: any
  displayDate: boolean = false;
  isCreate: boolean = false;
  selectedIndex = 0;
  total = 0;
  mealTotal = 0;
  perDiemTotal = 0
  saveMode = 1;
  itineraryId:any;
  objArray = [];
  miscItem = [];
  travelType = TRAVELTYPE;
  arr: FormArray;
  options: City[] = [
    {name: 'Manila'},
    {name: 'Cebu'},
    
  ];

  account_name: any;
  account_id: any;

  filteredOptions: Observable<string[]>;
  filteredEmployeeID: Observable<string[]>;
  filteredEmployeeName: Observable<string[]>;
  filterCity = JSON.parse(localStorage.getItem('citylist'));
  filterEmployee = JSON.parse(localStorage.getItem('employeelist'));
  cityLabel:any;


  constructor(
    public dialogRef: MatDialogRef<TravelAuthorizationAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public travelService: TravelService,
    public auth: AuthService,
    public functionService: FunctionsService,
    private formBuilder: FormBuilder,
    public addressService: AddressService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this._user = new User(this.auth.getAuthUser());
    this.formGroup = this.formBuilder.group({
      date_submitted:['',null],
      itinerary_date: ['',null],
      travel_authorization_no: ['',null],
      travel_authorization_id: ['',null],
      travel_request_id: ['',null],
      complete_name:['',null],
      employee_id_no: ['',null],
      position: ['',null],
      area_covered: ['',null],
      payroll_acct_no: ['',null],
      copy_date: ['',null],
      nature: ['',null],
      representation:['',null],
      miscellaneous:['',null],
      amount: ['',null],
      booked_by: ['',null],
      booking_method: ['',null],
      bill_to: ['',null],
      is_draft: ['',null],
      accommodation_cost: ['',null],
      travel_itinerary_details:['',null],
      is_lunch:['',null],
      is_dinner:['',null],
      is_breakfast: ['',null],
      meal:['',null],
      per_diem:['',null],
      others:['',null],
      itinerary_miscellaneous: this.formBuilder.array([]),
      travel_request_type:['',null],
      employee_name:['',null],
      employee_id: ['',null],
      level:['',null],
      department: ['',null],
      area_assigned:['',null],
      travel_type: ['',null],
      purpose: ['',null],
      location: ['',null],
      booking_type: ['',null],
      booking_type_itinerary: ['',null],
      inclusive_date_from: ['',null],
      inclusive_date_to: ['',null],
      currency: ['',null],
      currency_category: ['',null],
      charged_to_category: ['',null],
      charged_to: ['',null],
    });
    this.travel = new Travel('');
    this.travel.formGroup = this.formGroup;
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';

    //this.formGroup.controls['employee_id_no'].setValue(this._user.employee_id);
    this.arr = this.formGroup.get('itinerary_miscellaneous') as FormArray;
    this.addressService.getMisc().subscribe(res => {
      this.miscItem = res;
      res.forEach(element => {
        this.objArray.push({
          name: element.name,
          miscellaneous_id: element.id,
          amount: '',
        });
        this.arr.push(this.formBuilder.group({
          name: [element.name,null],
          miscellaneous_id: [element.id,null],
          amount: ['',null],
        }));
      });
    });
  
    //set Temporary value in order to proceed
    this.formGroup.controls['bill_to'].setValue(' ');
    this.formGroup.controls['booked_by'].setValue(' ');
    this.formGroup.controls['currency_category'].setValue('');

    this.formGroup.controls['accommodation_cost'].disable();

    this.filteredOptions = this.formGroup.get('location').valueChanges
    .pipe(
    startWith(''),
    map(val => this._filter(val))
    );

    this.filteredEmployeeName = this.formGroup.get('employee_name').valueChanges
    .pipe(
    startWith(''),
    map(val => this._filterEmployee(val,'employee_name'))
    );

    this.filteredEmployeeID = this.formGroup.get('employee_id').valueChanges
    .pipe(
    startWith(''),
    map(val => this._filterEmployee(val,'employee_id'))
    );

    this.formGroup.get('purpose').valueChanges.subscribe(value => {
      if (value == "OTHERS") {
        this.isOther = true;
        this.formGroup.controls['others'].reset();
      } else {
        this.isOther = false;
      }
    });

    //accommodation logic
    this.formGroup.get('booking_type_itinerary').valueChanges.subscribe(value => {
      if (value.toLowerCase() == "office" && this.formGroup.get('booking_method').value.toLowerCase() == "book only") {
        this.formGroup.controls['accommodation_cost'].enable();
      } else if (value.toLowerCase() == "self" && this.formGroup.get('booking_method').value.toLowerCase() == "book and pay"){
        this.formGroup.controls['accommodation_cost'].enable();
      } else {
        if (this.formGroup.controls['accommodation_cost'].value == '' || this.formGroup.controls['accommodation_cost'].value != 0) {
          this.formGroup.controls['accommodation_cost'].setValue(0);
        }
        this.formGroup.controls['accommodation_cost'].disable();
      }
    });

    //accommodation logic
    this.formGroup.get('booking_method').valueChanges.subscribe(value => {
      if (value.toLowerCase() == "book only" && this.formGroup.get('booking_type_itinerary').value.toLowerCase() == "office") {
        this.formGroup.controls['accommodation_cost'].enable();
      } else if (value.toLowerCase() == "book and pay" && this.formGroup.get('booking_type_itinerary').value.toLowerCase() == "self"){
        this.formGroup.controls['accommodation_cost'].enable();
      } else {
        if (this.formGroup.controls['accommodation_cost'].value == '' || this.formGroup.controls['accommodation_cost'].value != 0) {
          this.formGroup.controls['accommodation_cost'].setValue(0);
        }
        this.formGroup.controls['accommodation_cost'].disable();
      }
    });

  }

  selectTravelRequest (e) {
    let currDate = new Date();
    let yesterday = new Date(currDate.getTime() - (24*60*60*1000));
    this.formGroup.controls['inclusive_date_from'].setValue(null);
    this.formGroup.controls['inclusive_date_to'].setValue(null);  
    if (e.value.toLowerCase() == 'reimbursement') {
    this.tDate = this.pipe.transform(yesterday, 'yyyy-MM-dd');
    this.mxDate = this.tDate;
    } else {
    this.tDate = '';
    this.mxDate = this.tDate;
    }
  }

  validInfo(name) {
    let result = (name == 'employee_id')? this.account_id: this.account_name;
    if (this.formGroup.controls[name].value != result) {
      this.formGroup.controls[name].setErrors({'invalid': true});
      this.formGroup.controls[name].markAsTouched();
      this.formGroup.controls[name].markAsDirty();
      return;
    }

      this.formGroup.controls['employee_id'].setErrors({'invalid': false});
      this.formGroup.controls['employee_id'].markAsUntouched();
      this.formGroup.controls['employee_id'].markAsPristine();

      this.formGroup.controls['employee_name'].setErrors({'invalid': false});
      this.formGroup.controls['employee_name'].markAsUntouched();
      this.formGroup.controls['employee_name'].markAsPristine();
  }

  searchCity(e) {
    let title =  e;
    if (title.length >= 2) {
      this.addressService.getCityList(title).subscribe(res=>{
        this.filterCity = res;
      });
    }
  }

  closeOnClick() {
    this.dialogRef.close(true);

    if (this.travel.itineraries && this.travel.itineraries.length > 0) {
      this.doneInfo = true;
    } else {
      this.doneInfo = false;
    }

    if (this.formGroup.controls['travel_request_id'].value) {
      // this.deleteAsDraft();
    }
  }

  setEmployee(e, type){
    if (type == 'employee_name') {
      this.isClickedName = true;
    } else {
      this.isClickedId = true;
    }

    this.employeeDetail = e;
    this.account_id = e.employee_id;
    this.account_name = e.employee_name;
    this.formGroup.controls['employee_name'].setValue(e.employee_name);
    this.formGroup.controls['employee_id'].setValue(e.employee_id);
    this.formGroup.controls['level'].setValue(e.level);
    this.formGroup.controls['department'].setValue(e.department);
    this.formGroup.controls['area_assigned'].setValue(e.area_assigned);

    this.formGroup.controls['employee_id'].setErrors({'invalid': false});
    this.formGroup.controls['employee_id'].markAsUntouched();
    this.formGroup.controls['employee_id'].markAsPristine();

    this.formGroup.controls['employee_name'].setErrors({'invalid': false});
    this.formGroup.controls['employee_name'].markAsUntouched();
    this.formGroup.controls['employee_name'].markAsPristine();
  }

  //Andrico Sean's part. auto populate per diem based on employee level. This method is trggered when the user
  //chooses employee name or employee id. commented the per diem line in display() becuase it overrides the event
  populatePerDiem(){
    let lvl = this.formGroup.controls['level'].value

    if(lvl == "MANAGER1"){
      this.perDiemTotal = 1000
    }
    else if(lvl == "MANAGER"){
      this.perDiemTotal = 1000
    }
    else if(lvl == "SUPERVISORY"){
      this.perDiemTotal = 800
    }
    else if(lvl == "MANAGER2"){
      this.perDiemTotal = 1000
    }
    else if(lvl == "EXECOM"){
      this.perDiemTotal = 2500
    }
    else{
      this.perDiemTotal = 150
    }

    this.formGroup.controls['per_diem'].setValue(this.perDiemTotal)
  }

  /**
   * Header Info Save
   */
  saveInfo(){

    this.loading = true;
    this.successMessage = '';
    let currency = '';
    let charged = '';

    let location = this._filter(this.formGroup.controls['location'].value);

    if (location[0] && (this.formGroup.controls['location'].value.length != location[0]['title'].length)) {
      // this.formGroup.controls['location'].setValue('');
    } else if(location.length == 0) {
      // this.formGroup.controls['location'].setValue('');
    }

    if (this.formGroup.controls['currency_category'].value != 3 && this.formGroup.controls['currency_category'].value != '') {
      currency = this.currencyOption[this.formGroup.controls['currency_category'].value-1].name ;
    } else{
      currency = this.formGroup.controls['currency'].value;
    }

    if (this.formGroup.controls['charged_to_category'].value != 3 && this.formGroup.controls['charged_to_category'].value != '') {
      charged = this.chargeOption[this.formGroup.controls['charged_to_category'].value-1].name;
    } else {
      charged = this.formGroup.controls['charged_to'].value;
    }
    let purpose = (this.formGroup.controls['others'].value == '')? this.formGroup.controls['purpose'].value : this.formGroup.controls['purpose'].value + '|' + this.formGroup.controls['others'].value ;
    if (this.formGroup.controls['others'].value == '') {
      this.formGroup.controls['purpose'].setValue(purpose);
    }
    this.formGroup.controls['currency'].setValue(currency);
    this.formGroup.controls['charged_to'].setValue(charged);
    this.formGroup.controls['inclusive_date_from'].setValue(this.pipe.transform(this.formGroup.controls['inclusive_date_from'].value, 'yyyy-MM-dd'));
    this.formGroup.controls['inclusive_date_to'].setValue(this.pipe.transform(this.formGroup.controls['inclusive_date_to'].value, 'yyyy-MM-dd'));
    this.forDate = this.fDate;
    this.currDate =  this.forDate;
    this.toDate = this.tDate;
    this.formGroup.controls['is_draft'].setValue(true);

    // Version 1.5
    let travel_request_type = this.formGroup.controls['travel_request_type'].value;
    this.formGroup.controls['travel_request_type'].setValue(travel_request_type);

    if(this.formGroup.controls['employee_name'].value != this.formGroup.controls['employee_id'].value){
      if(this.formGroup.controls['employee_name'].value.toLowerCase() == this.nameEmployeeCompare.toLowerCase()){
        this.nameAndIdMismatch = true
        this.nameMismatch = false
      }
      else{
        this.nameAndIdMismatch = false
        this.nameMismatch = true
      }
    }

    if(this.formGroup.controls['employee_name'].value == '' || this.formGroup.controls['employee_id'].value == ''){
      this.nameAndIdMismatch = false
      this.nameMismatch = true
    }

    if (this.formGroup.controls['travel_request_id'].value == '') {
      this.travelService.storeRequestInfo(this.formGroup.value).subscribe(res=>{
        this.loading = false;
        this.formGroup.controls['travel_request_id'].setValue(res['data'].data[0].id);
        this.selectedIndex=1;
      },(err =>{
        this.loading = false;
        if(err.error.errors.employee_name){
          this.nameAndIdMismatch = false
          this.nameMismatch = true
        }
        this.travel.setErrors(err.error.errors);
        this.travel.triggerErrors(err.error.errors);
      }));
    } else {
      this.travelService.updateRequestInfo(this.formGroup.controls['travel_request_id'].value,this.formGroup.value).subscribe(res=>{
        this.loading = false;
        this.formGroup.controls['travel_request_id'].setValue(res['data'].data[0].id);
        this.selectedIndex=1;
      },(err =>{
        this.loading = false;
        if(err.error.errors.employee_name){
          this.nameAndIdMismatch = false
          this.nameMismatch = true
        }
        this.travel.setErrors(err.error.errors);
        this.travel.triggerErrors(err.error.errors);
      }));
    }

  }

  createItem(): FormGroup {
    return this.formBuilder.group({
        name: ['',null],
        miscellaneous_id: ['',null],
        amount: ['',null],
    });
  }

  /**
   * 1 = country
   * 2 = province
   * 3 =  city
   * 4 = barangay
   * @param i 
   */
  locationLookUp(i?:number,formInput?:string,mode?:string){
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.width = '605px';
    this.dialogConfig.data = {
        i,
        city: this.filterCity,
        barangay: null
    }
    let dialogRef = this.dialog.open(LookUpLocationComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.formGroup.controls[formInput].setValue(result.value);
      }
    });
  }


  /**
   * Compute Meal Veal as per option
   * @param e 
   * @param i 
   */
  mealvalue(e,i) {
    let lvl = this.formGroup.controls['level'].value

    switch (i) {
      case 1:
        this.formGroup.controls['is_breakfast'].setValue((i == 1 && e.checked)? 1 : 0 );
        break;
      case 2:
        this.formGroup.controls['is_lunch'].setValue((i == 2  && e.checked)? 1 : 0 );
        break;
      case 3:
        this.formGroup.controls['is_dinner'].setValue((i == 3  && e.checked)? 1 : 0 );
      break;
      default:
        break;
    }

    //Andrico Sean modified code
    if (e.checked) {
      if(lvl == "MANAGER"){
        this.mealTotal += 100;
      }
      else if(lvl == "MANAGER1"){
        this.mealTotal += 100;
      }
      else if(lvl == "MANAGER2"){
        this.mealTotal += 100;
      }
      else if(lvl == "EXECOM"){
        this.mealTotal += 150;
      }
      else{
        this.mealTotal += 50;
      }
  
    }
    else {
      if(lvl == "MANAGER"){
        this.mealTotal -= 100;
      }
      else if(lvl == "MANAGER1"){
        this.mealTotal -= 100;
      }
      else if(lvl == "MANAGER2"){
        this.mealTotal -= 100;
      }
      else if(lvl == "EXECOM"){
        this.mealTotal -= 150;
      }
      else{
        this.mealTotal -= 50;
      } 
    }

    this.formGroup.controls['meal'].setValue(this.mealTotal);
  }

  //this funciton is triggered when the employee name or id is changed
  mealReset(){
    this.mealTotal = 0;
    this.formGroup.controls['meal'].setValue(this.mealTotal);
    this.formGroup.controls['is_breakfast'].setValue('');
    this.formGroup.controls['is_lunch'].setValue('');
    this.formGroup.controls['is_dinner'].setValue('');
  }

  autoPopulateMeal(){
    let lvl = this.formGroup.controls['level'].value

    if(lvl == "MANAGER"){
      this.mealTotal += 300;
    }
    else if(lvl == "MANAGER1"){
      this.mealTotal += 300;
    }
    else if(lvl == "MANAGER2"){
      this.mealTotal += 300;
    }
    else if(lvl == "EXECOM"){
      this.mealTotal += 450;
    }
    else{
      this.mealTotal += 150;
    }
    this.formGroup.controls['meal'].setValue(this.mealTotal);
    this.formGroup.controls['is_breakfast'].setValue(1)
    this.formGroup.controls['is_lunch'].setValue(1)
    this.formGroup.controls['is_dinner'].setValue(1)
  }

  /**
   * Save Itinerary
   */
  saveItinerary() {
    this.loading = true;

    if (this.saveMode == 0) {
      
      this.travelService.updateItinerary(this.itineraryId,this.formGroup.getRawValue()).subscribe(res=>{
        this.loading = false;
        this.travel.itineraries = res['data'].data[0].travel_itineraries;
        this.travel.summary_list = [];
        this.displayForm = false;

        //Display Summary Expenses
        this.expensesList  = this.functionService.loopRangeDate(
          [res['data'].data[0].travel_summary.inclusive_date_from,res['data'].data[0].travel_summary.inclusive_date_to],
           res['data'].data[0].travel_itineraries
        );
        if (this.pipe.transform(this.formGroup.controls['itinerary_date'].value, 'yyyy-MM-dd') == this.tDate) { 
          this.selectedIndex = 2;
          this.formGroup.controls['itinerary_date'].setValue('');
        } else {
          let currentDate = this.incrementDates(this.pipe.transform(this.formGroup.controls['itinerary_date'].value, 'yyyy-MM-dd'));
          this.formGroup.controls['itinerary_date'].setValue(currentDate);
          this.searchDate();
          this.itineraryId = 0;
        }

        this.travel.clearTotal();
        this.travel.getTotal();  
        this.loading = false;
      },(err =>{
        this.loading = false;
        this.travel.setErrors(err.error.errors);
        this.travel.triggerErrors(err.error.errors);
      }));
    } else {
      this.formGroup.controls['itinerary_date'].setValue(this.pipe.transform(this.formGroup.controls['itinerary_date'].value, 'yyyy-MM-dd'));
      this.formGroup.controls['travel_itinerary_details'].setValue(this.travel.summary_list);
      
      this.travelService.storeIntinerary(this.formGroup.getRawValue()).subscribe(res=>{
        this.loading = false;
        this.travel.itineraries = res['data'].data[0].travel_itineraries;
        this.travel.summary_list = [];
        this.isCreate = false;
        this.countdays.push(1);

        //Display Summary Expenses
        this.expensesList  = this.functionService.loopRangeDate(
          [res['data'].data[0].travel_summary.inclusive_date_from,res['data'].data[0].travel_summary.inclusive_date_to],
          res['data'].data[0].travel_itineraries
        );
        this.travel.clearTotal();
        if (this.pipe.transform(this.formGroup.controls['itinerary_date'].value, 'yyyy-MM-dd') == this.tDate) {
          this.travel.getTotal();
          this.selectedIndex = 2;
          this.formGroup.controls['itinerary_date'].setValue('');
          this.displayForm = false;
          this.displayDate = false;
        } else {
          this.currDate  = this.incrementDates(this.pipe.transform(this.formGroup.controls['itinerary_date'].value, 'yyyy-MM-dd'));
          this.clear();
          this.formGroup.controls['itinerary_date'].setValue(this.currDate);
          this.searchDate();
          this.itineraryId = 0;
          this.displayForm = false;
          this.displayDate = false;
        }

        this.loading = false;
      },(err =>{
        this.loading = false;
        this.travel.setErrors(err.error.errors);
        this.travel.triggerErrors(err.error.errors);
      }));
    }
    
  }

  /**
   * Hide itinerary form
   */
  hideItinerary() {
   let dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      disableClose:true,
      data: {
        message: "Are you sure you want to delete this itinerary?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.delete();
      }
    });
  }

  delete() {
    this.loading = true;
    if (this.itineraryId && this.travel.id) {
      
      this.travelService.deleteItinerary(this.itineraryId,this.travel.id).subscribe(res=>{
        this.travel.itineraries = res['data'].data[0].travel_itineraries;

        if (this.travel.itineraries && this.travel.itineraries.length >= 1) {
          this.travel.fromDatePicker = true;
        } else {
          this.travel.fromDatePicker = false;
        }

        this.travel.clearTotal();
        this.travel.id = null;
        this.countdays.shift();
        this.loading = false;
        this.dialog.open(NotifyboxComponent, {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            message: res['message']
          }
        });
      },(err => {
        this.loading = false;
        this.travel.id = null;
      }));
    } else {
      this.loading = false;
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          message: 'The itinerary has been deleted.'
        }
      });
    } 
    this.clear();
    this.isCreate = false;
    this.travel.resetErrors();
    this.travel.summary_list = [];
    this.travel.itineraries = [];
    this.displayForm = false;
    this.displayDate = false;
  }

  close() {
    this.msg = "";
  }

  /**
   * Copy date from prevoius
   */
  copyDate() {
    this.travel.resetErrors();
    let id = this.formGroup.controls['travel_request_id'].value;
    let previous_date = this.fDate;
    
    for(let i=0;i < this.travel.itineraries.length;i++) {
      if (_moment(this.travel.itineraries[i].itinerary_date) < _moment(this.travel.itinerary_date)) {
        previous_date = this.travel.itineraries[i].itinerary_date;
        for(let c=0;c < this.travel.itineraries.length;c++) {
          if (_moment(previous_date) > _moment(this.travel.itineraries[c].itinerary_date) &&
          _moment(this.travel.itinerary_date) < _moment(this.travel.itineraries[c].itinerary_date)) {
            previous_date = this.travel.itineraries[c].itinerary_date;
            break;
          }
        }
      }
    }

    this.travelService.url= travelRequestUrl+'/copy?request_id='+id+'&date='+previous_date;
    
    this.travelService.getFilter().subscribe(res=>{
      this.formGroup.controls['accommodation_cost'].setValue(res.travel_itinerary_first.accommodation_cost);
      this.formGroup.controls['booked_by'].setValue(res.travel_itinerary_first.booked_by);
      this.formGroup.controls['bill_to'].setValue(res.travel_itinerary_first.bill_to);
      this.formGroup.controls['per_diem'].setValue(res.travel_itinerary_first.per_diem);
      //this.perDiemTotal = res.travel_itinerary_first.per_diem;//sean edit
      

      this.formGroup.controls['representation'].setValue(res.travel_itinerary_first.representation);
      this.formGroup.controls['miscellaneous'].setValue(res.travel_itinerary_first.miscellaneous);
      this.formGroup.controls['meal'].setValue(res.travel_itinerary_first.meal);

      this.mealTotal = res.travel_itinerary_first.meal;

      this.formGroup.controls['is_breakfast'].setValue(res.travel_itinerary_first.is_breakfast);
      this.formGroup.controls['is_dinner'].setValue(res.travel_itinerary_first.is_dinner);
      this.formGroup.controls['is_lunch'].setValue(res.travel_itinerary_first.is_lunch);
      this.travel.summary_list = res.travel_itinerary_first.travel_itinerary_details;

      this.formGroup.controls['booking_type_itinerary'].setValue(res.travel_itinerary_first.booking_type || '');
      this.formGroup.controls['booking_method'].setValue(res.travel_itinerary_first.booking_method || '');

      //disable cost
      if (res.travel_itinerary_first.booking_type == "Office" && res.travel_itinerary_first.booking_method == "Book Only") {
        this.formGroup.controls['accommodation_cost'].enable();
        this.formGroup.controls['accommodation_cost'].setValue(res.travel_itinerary_first.accommodation_cost);
      } else if (res.travel_itinerary_first.booking_type == "Self" && res.travel_itinerary_first.booking_method == "Book and Pay"){
        this.formGroup.controls['accommodation_cost'].enable();
        this.formGroup.controls['accommodation_cost'].setValue(res.travel_itinerary_first.accommodation_cost);
      } else {
        if (this.formGroup.controls['accommodation_cost'].value == '' || this.formGroup.controls['accommodation_cost'].value != 0) {
          this.formGroup.controls['accommodation_cost'].setValue(0);
        }
        this.formGroup.controls['accommodation_cost'].disable();
      }

      if (res.travel_itineraries[0].itinerary_miscellaneous) {

        res.travel_itineraries[0].itinerary_miscellaneous.forEach((element,i) => {
          (<FormArray>this.formGroup.controls['itinerary_miscellaneous']).at(i).patchValue({
            name: element.name,
            miscellaneous_id: element.miscellaneous_id,
            amount: element.amount,
          });
        });
      }
    },(err => {

    }));
  }

  /**
   *  Add Summary Modal Component
   */
  createSummary(){
    this.travel._errors = {};
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.width = '100vw';
    this.dialogConfig.data = {
      mode: 0,
      travel: this.travel
    }
    let dialogRef = this.dialog.open(TravelSummaryAddComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result != '') {
        console.log(result);
        this.travel._errors['travel_itinerary_details'] = '';
        this.travel.formGroup = this.formGroup;
        this.travel = result;
      }
    });
  }

  /**
   * Search date data
   * @param event 
   */
  searchDate(event?: MatDatepickerInputEvent<Date>){
      let valueDate = (event)? event.value : this.formGroup.controls['itinerary_date'].value;
      let itineraryDate = this.pipe.transform(valueDate, 'yyyy-MM-dd');
      this.travel.itinerary_date = itineraryDate;

      let id = this.formGroup.controls['travel_request_id'].value;
      this.travelService.url= travelItineraryUrl+'/search?request_id='+id+'&itinerary_date='+itineraryDate;
      
      this.travelService.getFilter().subscribe(res=>{
        if (res.id) {
          this.travel.itinerary_date = itineraryDate;
          this.displayForm = true;
          this.canDelete = true;
          this.itineraryId = res.id;
          this.travel.id =  res.travel_request_id;
          this.saveMode = 0;
          this.displayDate = false;
          this.travel.summary_list = [];
          this.travel._errors = {};
          //this.clear();//disabled because this overwrites accommodation cost to 0
          this.formGroup.controls['accommodation_cost'].setValue(res.accommodation_cost);
          this.formGroup.controls['booked_by'].setValue(res.booked_by);
          this.formGroup.controls['bill_to'].setValue(res.bill_to);
          this.formGroup.controls['per_diem'].setValue(res.per_diem);
          this.formGroup.controls['meal'].setValue(res.meal);
          this.formGroup.controls['representation'].setValue(res.representation);
          this.formGroup.controls['miscellaneous'].setValue(res.miscellaneous);
          this.formGroup.controls['booking_type_itinerary'].setValue(res.booking_type);
          this.formGroup.controls['booking_method'].setValue(res.booking_method);
          this.formGroup.controls['meal'].setValue(res.meal);
          this.formGroup.controls['is_breakfast'].setValue(res.is_breakfast);
          this.formGroup.controls['is_dinner'].setValue(res.is_dinner);
          this.formGroup.controls['is_lunch'].setValue(res.is_lunch);
          this.travel.summary_list = res.travel_itinerary_details;
          this.formGroup.controls['travel_itinerary_details'].setValue(res.travel_itinerary_details);
          this.formGroup.controls['itinerary_date'].setValue(itineraryDate);
          if (res.itinerary_miscellaneous) {
            res.itinerary_miscellaneous.forEach((element,i) => {
              (<FormArray>this.formGroup.controls['itinerary_miscellaneous']).at(i).patchValue({
                name: element.name,
                miscellaneous_id: element.miscellaneous_id,
                amount: element.amount,
              });
            });
          }

          if (this.travel.itineraries.length >= 1) {
            this.countdays.push(1);
          }
        } else {
          this.saveMode = 1;
          this.displayForm = false;
          this.canDelete = false;
        }
      },(err => {

      }));  

      if (this.travel._errors) {
        this.travel._errors = {}
      }
  }

  /**
   * Set Travel Authorization Data
   * as Draft to true
   */
  saveAsDraft(bool:boolean) {
    this.loading = true;
    this.formGroup.controls['is_draft'].setValue(bool);
    this.travelService.updateRequestInfo(this.formGroup.controls['travel_request_id'].value,this.formGroup.getRawValue()).subscribe(res=>{
      this.loading =  false
      
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          isclose:true,
          message: res['message']
        }
      }).afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close(true);
        }
      });
      this.loading = false;

    },(err =>{
      this.loading = false;
      this.travel.setErrors(err.error.errors);
      this.travel.triggerErrors(err.error.errors);
    }));
  }

  /**
   * Display Itinerary
   */
  display(){
    this.loading = true;
    let id = this.formGroup.controls['travel_request_id'].value;
    let itinerary_date = this.pipe.transform(this.formGroup.controls['itinerary_date'].value, 'yyyy-MM-dd');
    this.formGroup.controls['itinerary_date'].setValue(itinerary_date);
    this.travelService.url= travelItineraryUrl+'/validate?travel_request_id='+id+'&itinerary_date='+itinerary_date;
    this.travel.summary_list = [];
    this.travel.resetErrors();
    
    this.formGroup.controls['booking_type_itinerary'].setValue('');
    this.formGroup.controls['booking_method'].setValue('');
    this.formGroup.controls['accommodation_cost'].setValue('');
    //this.formGroup.controls['per_diem'].setValue('');//Commented because it overrides populatePerDiem()
    //this.formGroup.controls['meal'].setValue('');
    //this.formGroup.controls['is_breakfast'].setValue('');
    //this.formGroup.controls['is_dinner'].setValue('');
    //this.formGroup.controls['is_lunch'].setValue('');

    this.travelService.getFilter().subscribe(res=>{
      
      this.isCreate = true;
      if (res) {
        this.loading = false;
        this.travel._errors = {};
        this.displayForm = true;
        if (this.countdays.length > 0) {
          this.displayDate = true;
        }
        this.miscItem.forEach((element,i) => {
          (<FormArray>this.formGroup.controls['itinerary_miscellaneous']).at(i).patchValue({
            name: element.name,
            miscellaneous_id: element.id,
            amount: ''
          });
        });  
      }  
    },(err => {
      if (err.status == 400) {
        err.error.errors.itinerary[0] = '';
      }
      this.travel.setErrors(err.error.errors);
      this.travel.triggerErrors(err.error.errors);
      this.loading = false;
    }));
  }

  next(e){
    this.selectedIndex=e;
  }

  back(e){
    this.travel._errors = {};
    this.travel.getTotal();
    if (this.travel.itineraries && this.travel.itineraries.length > 0) {
      this.doneInfo = true;
      this.formGroup.controls['itinerary_date'].setValue(this.fDate);
      this.searchDate();
      this.formGroup.controls['accommodation_cost'].enable()
    } else {
      this.doneInfo = false;
      this.displayForm = false;
      this.isCreate = false;
      this.formGroup.controls['itinerary_date'].reset();
    }
    this.selectedIndex=e;
  }

  onChangeStartDate(e) {
    this.fDate = this.pipe.transform(e.value, 'yyyy-MM-dd');
  }

  onChangeEndDate(e) {
    this.tDate = this.pipe.transform(e.value, 'yyyy-MM-dd');
  }

  keypressValidateNumber(e,max) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g); // '\d'
     return pattern.test(e.key);
  }

  /**
   * Number validation on input fields
   */  
  keypressValidateNumberDecimal(e) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g);
    const rgx = /^[0-9]*\.?[0-9]*$/;
    if ((e.key == '.' && e.target.value.includes('.')) || !pattern.test(e.key)) {
      return false;
    }
    return (e.target.value.match(rgx)) ? true : false;
  }

  /**
   * Delete Travel Authorization Data
   */
  deleteAsDraft() {
    this.loading = true;
    let data = {
      status: 'Delete as Draft',

    }
    this.travelService.updateStatus(this.formGroup.controls['travel_request_id'].value,data).subscribe(res=>{
      
      this.dialogRef.close(true);
    },(err =>{
      this.loading = false;
      this.travel.setErrors(err.error.errors);
      this.travel.triggerErrors(err.error.errors);
    }));
  }



  /**
   * Summary add Detail
   * mode temporay data
   * @param res 
   */
  editSummary(res,i) {
    this.dialogConfig.width = '100vw';
    this.dialogConfig.data = {
      res,
      list:this.travel.summary_list,
      travel: this.travel,
      mode: 0,
      index:i,
      is_draft: true
    }
    let dialogRef = this.dialog.open(TravelSummaryViewComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result != '') {
        this.travel.formGroup = this.formGroup;
        this.travel.summary_list = result;
      }
    });
  }

  /**
   * Delete summary list
   * @param i = index in the list
   */
  deleteSummary(i) {
    let dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      disableClose:true,
      data: {
        message: "Are you sure you want to delete this itinerary?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteSummaryConfirm();
      }
    });
    this.index = i;
  }

  deleteSummaryConfirm() {
    this.removeRow(this.index,this.travel.summary_list);
    this.summarymsg = "";
    this.dialog.open(NotifyboxComponent, {
      disableClose:true,
      data: {
        reload:false,
        label:'Ok',
        message: 'Itinerary has been deleted.'
      }
    });
  }

  closeSummary() {
    this.summarymsg = "";
    this.index = 0;
  }

  /**
   * Booking add Detail
   * mode temporary data
   * @param res 
   */
  editBooking(res,i) {
    this.dialogConfig.width = '100vw';
    this.dialogConfig.data = {
      res,
      list:this.travel.booking_details_list,
      mode: 0,
      index:i,
      is_draft:true,
      itinerary_date: this.formGroup.controls['itinerary_date'].value
    }
    let dialogRef = this.dialog.open(TravelBookingViewComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result != '') {
        this.travel.booking_details_list = result;
        this.formGroup.controls['tb_details'].setValue(this.travel.booking_details_list);
      }
    });
  }

  /**
   * Display Currency option
   * @param e = 3 get value for other currency
   */
  displayCurrency(e) {
    this.formGroup.get('currency_category').valueChanges.subscribe(value => { 
      if (value == 3) {
        this.formGroup.controls['currency'].setValue('');
        this.isCurrency = true;
      } else {
        this.isCurrency = false;
      }
    })
  }

  /**
   * Display other supplier
   * @param e  e = 3 get value for supplier
   */
  displayCharge(e) {
    this.formGroup.get('charged_to_category').valueChanges.subscribe(value => { 
      if (value == 3) {
        this.isCharged = true;
        this.formGroup.controls['charged_to'].setValue('');
      } else {
        this.isCharged = false;
        this.formGroup.controls['charged_to'].setValue('');
      }
    })
  }

  /**
   * Remove in Object Array
   * @param index index key
   * @param data list
   */
  removeRow(index,data){
    data.splice(index, 1);
  }

  /**
   * Clear form procceed to next date
   */
  clear() {
    this.formGroup.controls['itinerary_date'].setValue('');
    this.formGroup.controls['accommodation_cost'].setValue('');
    this.formGroup.controls['booked_by'].setValue('');
    this.formGroup.controls['bill_to'].setValue('');
    this.formGroup.controls['representation'].setValue('');
    this.formGroup.controls['miscellaneous'].setValue('');
    this.formGroup.controls['per_diem'].setValue('');
    this.formGroup.controls['meal'].setValue('');
    this.formGroup.controls['is_breakfast'].setValue('');
    this.formGroup.controls['is_lunch'].setValue('');
    this.formGroup.controls['is_dinner'].setValue('');
    //this.mealTotal = 0;//sean modified
    //this.perDiemTotal = 0;

    this.formGroup.controls['booking_type_itinerary'].setValue('');
    this.formGroup.controls['booking_method'].setValue('');
  }

  /**
   * Get days between Dates
   */
  countDays() {
    var diff = Math.abs(this.fDate.getTime() - this.tDate.getTime());
    return Math.ceil(diff / (1000 * 3600 * 24)); 
  }

  /**
   * Increment current day as per day
   * @param dateString 
   */
  incrementDates(dateString) {
    var result = new Date(new Date(dateString).setDate(new Date(dateString).getDate() + 1));
    return result.toISOString().substr(0, 10);
  }

  displayFn(city: City) {
    if (city) { return city.name; }
  }

  dataCheckerName(event) {
    if (this.formGroup.get('employee_name').value === '') {
      this.isClickedName = false;
    }
  }

  dataCheckerId(event) {
    if (this.formGroup.get('employee_id').value === '') {
      this.isClickedId = false;
    }
  }

  private _filter(name: string): string[] {
    const filterValue = name.toLowerCase();
    return this.filterCity.filter(option => option.title.toLowerCase().includes(filterValue));
  }

  private _filterEmployee(name: string, option?: string): string[] {
    const filterValue = name.toLowerCase();
    if (option == 'employee_id') {
      return this.filterEmployee.filter(option => option.employee_id.toLowerCase().includes(filterValue));
    } else {
      let i = this.filterEmployee.filter(option => option.employee_name.toLowerCase().includes(filterValue));
      if(i != ''){
        this.nameEmployeeCompare = i[0].employee_name
      }
      return i
    }
   
  }

}
